<div class="app-page-title">
  <div class="page-title-wrapper">
    <div class="page-title-heading">
      <div class="page-title-icon">
        <i class="pe-7s-user icon-gradient bg-mean-fruit"> </i>
      </div>
      <div>
        {{ "data.provider" | translate }}
        <div class="page-title-subheading">
          {{ "data.add_provider" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="providerForm" (ngSubmit)="addProvider()">
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="card-header">
              {{ "data.general_info_pro" | translate }}
            </div>
            <div class="card-body">
              <div class="row form-group">
                <div class="col-4">
                  <div class="form-group">
                    <div class="Neon Neon-theme-dragdropbox">
                      <input
                        style="
                          z-index: 999;
                          opacity: 0;
                          width: 320px;
                          height: 200px;
                          position: absolute;
                          right: 0px;
                          left: 0px;
                          margin-right: auto;
                          margin-left: auto;
                        "
                        name="file"
                        id="file"
                        #file
                        accept="image/*"
                        (change)="handleFileInput($event)"
                        type="file"
                      />
                      <div class="Neon-input-dragDrop">
                        <div class="Neon-input-inner">
                          <div
                            class="Neon-input-icon"
                            *ngIf="
                              providerForm.get('logoSociety')?.value == '' ||
                              providerForm.get('logoSociety')?.value == null
                            "
                          >
                            <i class="fa fa-file-image-o"></i>
                          </div>
                          <div
                            class="Neon-input-icon"
                            *ngIf="
                              providerForm.get('logoSociety')?.value != null
                            "
                          >
                            <img
                              [src]="
                                env.logoSocietyAssetsBaseURL +
                                providerForm.get('logoSociety')?.value
                              "
                              style="width: 100px"
                            />
                          </div>
                          <div class="Neon-input-text">
                            <h3>Drag&amp;Drop files here</h3>
                            <span style="display: inline-block; margin: 5px 0"
                              >or</span
                            >
                          </div>
                          <a class="Neon-input-choose-btn blue">Browse Files</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8">
                  <div class="row">
                    <div class="col-12 col-md-6 form-group">
                      <legend for="providerName" class="">
                        {{ "data.name_society" | translate }} *
                      </legend>
                      <input
                        name="providerName"
                        id="providerName"
                        type="text"
                        class="form-control"
                        formControlName="providerName"
                        [class]="
                          providerForm.get('providerName')?.touched &&
                          providerForm.get('providerName')?.invalid
                            ? 'input-border-danger'
                            : ''
                        "
                      />
                    </div>
                    <div class="col-12 col-md-6 form-group">
                      <legend for="providerDescription" class="">
                        {{ "data.desc_society" | translate }}
                      </legend>
                      <input
                        name="providerDescription"
                        id="providerDescription"
                        type="text"
                        class="form-control"
                        formControlName="providerDescription"
                      />
                    </div>
                    <div class="col-12 col-md-6 form-group">
                      <legend for="providerCode" class="">
                        {{ "data.code_pro" | translate }} *
                      </legend>
                      <input
                        name="providerCode"
                        id="providerCode"
                        type="text"
                        class="form-control"
                        formControlName="providerCode"
                        [class]="
                          providerForm.get('providerCode')?.touched &&
                          providerForm.get('providerCode')?.invalid
                            ? 'input-border-danger'
                            : ''
                        "
                      />
                    </div>
                    <div class="col-12 col-md-6 form-group">
                      <legend for="numberSiret" class="">
                        {{ "data.number_siret" | translate }}
                      </legend>
                      <input
                        name="numberSiret"
                        id="numberSiret"
                        type="text"
                        class="form-control"
                        formControlName="numberSiret"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="card-header">
              {{ "data.provider_details" | translate }}
            </div>
            <div class="card-body">
              <div class="row form-group">
                <div class="col-md-3 form-group">
                  <div class="position-relative form-group">
                    <legend for="email_society" class="">
                      {{ "data.email" | translate }} *
                    </legend>
                    <input
                      name="email_society"
                      id="email_society"
                      type="text"
                      class="form-control"
                      formControlName="email_society"
                      [class]="
                        providerForm.get('email_society')?.touched &&
                        providerForm.get('email_society')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-md-3 form-group">
                  <div class="position-relative form-group">
                    <legend for="siteWeb" class="">
                      {{ "data.web_site" | translate }}
                    </legend>
                    <input
                      name="siteWeb"
                      id="siteWeb"
                      type="text"
                      class="form-control"
                      formControlName="siteWeb"
                    />
                  </div>
                </div>
                <div class="col-md-3 form-group">
                  <div class="position-relative form-group">
                    <legend for="numTel_society" class="">
                      {{ "data.phone" | translate }} *
                    </legend>
                    <input
                      name="numTel_society"
                      id="numTel_society"
                      type="number"
                      class="form-control"
                      formControlName="numTel_society"
                      [class]="
                        providerForm.get('numTel_society')?.touched &&
                        providerForm.get('numTel_society')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-md-3 form-group">
                  <div class="position-relative form-group">
                    <legend for="incoterm" class="">Incoterm *</legend>
                    <select
                      class="form-control"
                      formControlName="incoterm"
                      name="incoterm"
                      id="incoterm"
                      [class]="
                        providerForm.get('incoterm')?.touched &&
                        providerForm.get('incoterm')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    >
                      <option>{{ "data.select" | translate }} incoterm</option>
                      <option [value]="item" *ngFor="let item of incoterms">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <!-- <div class="col-md-3 form-group">
                <legend for="adress" class="">
                  {{ "data.main_address" | translate }} *
                </legend>

                <input type="text" name="adress" id="adress" class="form-control" #autoInput matInput
                    [matAutocomplete]="auto" (input)="onChange('adressSociety')"
                    [class]="(!isSaved && !provider.adressSociety) ? 'input-border-danger' : ''">

                <mat-autocomplete #auto="matAutocomplete"
                    (optionSelected)="onSelectionChange($event, 'adressSociety')">
                    <mat-option *ngFor="let place of places" [value]="place">
                        {{ place.description }}
                    </mat-option>
                </mat-autocomplete>
              </div> -->
                <div class="col-md-5 form-group">
                  <div class="position-relative form-group">
                    <legend for="fullAddress" class="">
                      {{ "data.full_address" | translate }} *
                    </legend>
                    <input
                      name="fullAddress"
                      id="fullAddress"
                      type="text"
                      class="form-control"
                      formControlName="fullAddress"
                      [class]="
                        providerForm.get('fullAddress')?.touched &&
                        providerForm.get('fullAddress')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-md-2 form-group">
                  <div class="position-relative form-group">
                    <legend for="country" class="">
                      {{ "data.country" | translate }} *
                    </legend>
                    <select
                      class="form-control"
                      formControlName="country"
                      placeholder="Sélectionnez le pays"
                      [class]="
                        providerForm.get('country')?.touched &&
                        providerForm.get('country')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    >
                      <option [value]="item" *ngFor="let item of countries">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="position-relative form-group">
                    <legend for="gerbable" class="">
                      {{ "data.stackable" | translate }} *
                    </legend>
                    <div class="position-relative form-group">
                      <div class="row col-12">
                        <input
                          id="stackable-yes"
                          name="stackable"
                          type="radio"
                          class="form-check-input"
                          formControlName="stackable"
                          [value]="true"
                        />
                        {{ "data.yes" | translate }}
                      </div>
                      <div class="row col-12">
                        <input
                          id="stackable-no"
                          name="stackable"
                          type="radio"
                          class="form-check-input"
                          formControlName="stackable"
                          [value]="false"
                        />
                        {{ "data.no" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="card-header">
              {{ "data.contact_principal" | translate }}
            </div>
            <div class="card-body">
              <div class="row form-group">
                <div class="col-md-3">
                  <div class="position-relative form-group">
                    <legend for="firstName" class="">
                      {{ "data.first_name" | translate }} *
                    </legend>
                    <input
                      name="firstName"
                      id="firstName"
                      type="text"
                      class="form-control"
                      formControlName="firstName"
                      [class]="
                        providerForm.get('firstName')?.touched &&
                        providerForm.get('firstName')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="position-relative form-group">
                    <legend for="lastName" class="">
                      {{ "data.last_name" | translate }} *
                    </legend>
                    <input
                      name="lastName"
                      id="lastName"
                      type="text"
                      class="form-control"
                      formControlName="lastName"
                      [class]="
                        providerForm.get('lastName')?.touched &&
                        providerForm.get('lastName')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div
                      class="col-12"
                      [class]="
                        !isOther(providerForm.get('labelPost')?.value)
                          ? 'col-md-12'
                          : 'col-md-6'
                      "
                    >
                      <legend for="labelPost" class="">
                        {{ "data.title_position" | translate }} *
                      </legend>
                      <select
                        class="form-control"
                        formControlName="labelPost"
                        name="labelPost"
                        id="labelPost"
                        (change)="selectContactPost($event)"
                        [class]="
                          providerForm.get('labelPost')?.touched &&
                          providerForm.get('labelPost')?.invalid
                            ? 'input-border-danger'
                            : ''
                        "
                      >
                        <option>
                          {{ "data.select_position" | translate }}
                        </option>
                        <option [value]="item" *ngFor="let item of posts">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="col-12 col-md-6"
                      *ngIf="isOther(providerForm.get('labelPost')?.value)"
                      style="margin-top: auto"
                    >
                      <input
                        name="otherPost"
                        id="otherPost"
                        type="text"
                        class="form-control"
                        formControlName="post"
                        [class]="
                          providerForm.get('post')?.touched &&
                          providerForm.get('post')?.invalid
                            ? 'input-border-danger'
                            : ''
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <legend for="username" class="">
                      {{ "data.email" | translate }} *
                    </legend>
                    <input
                      name="username"
                      id="username"
                      type="text"
                      class="form-control"
                      formControlName="username"
                      [class]="
                        providerForm.get('username')?.touched &&
                        providerForm.get('username')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <legend for="numTel" class="">
                    {{ "data.phone" | translate }} *
                  </legend>
                  <input
                    name="numTel"
                    id="numTel"
                    type="number"
                    class="form-control"
                    formControlName="numTel"
                    [class]="
                      providerForm.get('numTel')?.touched &&
                      providerForm.get('numTel')?.invalid
                        ? 'input-border-danger'
                        : ''
                    "
                  />
                </div>

                <div class="col-md-4 form-group">
                  <legend for="numTel2" class="">
                    {{ "data.phone" | translate }} 2
                  </legend>
                  <input
                    name="numTel2"
                    id="numTel2"
                    type="number"
                    class="form-control"
                    formControlName="numTel2"
                  />
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <legend for="password" class="">Password *</legend>
                    <input
                      name="password"
                      id="password"
                      type="text"
                      class="form-control"
                      formControlName="password"
                      [class]="
                        providerForm.get('password')?.touched &&
                        providerForm.get('password')?.invalid
                          ? 'input-border-danger'
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-header-title">
            <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure">
            </i>
            Contacts
          </div>
          <div class="btn-actions-pane-right">
            <button
              type="button"
              (click)="addNewContactGroup()"
              class="mt-1 btn btn-warning"
            >
              <i class="pe-7s-plus"></i> {{ "data.add" | translate }}
            </button>
          </div>
        </div>
        <div class="card-body">
          <div formArrayName="contacts">
            <div *ngFor="let contact of contacts.controls; let i = index">
              <div
                class="position-relative row form-group"
                [formGroupName]="i"
                style="margin-top: 10px"
              >
                <div class="col-12 div-contact">
                  <div class="row">
                    <div class="col-12 col-md-11">
                      <div class="row form-group">
                        <div class="col-md-3">
                          <div class="position-relative form-group">
                            <legend for="firstName" class="">
                              {{ "data.first_name" | translate }} *
                            </legend>
                            <input
                              name="firstName"
                              id="firstName"
                              type="text"
                              class="form-control"
                              formControlName="firstName"
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="position-relative form-group">
                            <legend for="lastName" class="">
                              {{ "data.last_name" | translate }} *
                            </legend>
                            <input
                              name="lastName"
                              id="lastName"
                              type="text"
                              class="form-control"
                              formControlName="lastName"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row">
                            <div
                              class="col-12"
                              [class]="
                                !isOther(contact.value.labelPost)
                                  ? 'col-md-12'
                                  : 'col-md-6'
                              "
                            >
                              <legend for="post" class="">
                                {{ "data.title_position" | translate }} *
                              </legend>
                              <select
                                class="form-control"
                                formControlName="labelPost"
                                name="post"
                                id="post"
                                (change)="selectPost($event, i)"
                              >
                                <option>
                                  {{ "data.select_position" | translate }}
                                </option>
                                <option
                                  [value]="item"
                                  *ngFor="let item of posts"
                                >
                                  {{ item }}
                                </option>
                              </select>
                            </div>
                            <div
                              class="col-12 col-md-6"
                              *ngIf="isOther(contact.value.labelPost)"
                              style="margin-top: auto"
                            >
                              <input
                                name="otherPost"
                                id="otherPost"
                                type="text"
                                class="form-control"
                                formControlName="post"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col-md-4">
                          <div class="position-relative form-group">
                            <legend for="username" class="">
                              {{ "data.email" | translate }} *
                            </legend>
                            <input
                              name="username"
                              id="username"
                              type="text"
                              class="form-control"
                              formControlName="email"
                            />
                          </div>
                        </div>
                        <div class="col-md-4 form-group">
                          <legend for="numTel" class="">
                            {{ "data.phone" | translate }} *
                          </legend>
                          <input
                            name="numTel"
                            id="numTel"
                            type="number"
                            class="form-control"
                            formControlName="numTel"
                          />
                        </div>

                        <div class="col-md-4 form-group">
                          <legend for="numTel2" class="">
                            {{ "data.phone" | translate }} 2
                          </legend>
                          <input
                            name="numTel2"
                            id="numTel2"
                            type="number"
                            class="form-control"
                            formControlName="numTel2"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-1 div-center">
                      <button
                        type="button"
                        (click)="deleteContactGroup(i)"
                        class="mr-2 btn-icon btn-icon-only btn btn-danger float-right"
                      >
                        <i class="pe-7s-trash btn-icon-wrapper"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="card-header">
              {{ "data.logistic_details" | translate }}
            </div>
            <div class="card-body">
              <div class="row form-group">
                <!-- <div class="col-md-4 form-group">
                <legend for="adress2" class="">
                  {{ "data.shipping_address" | translate }}<br />{{
                    "data.if_different" | translate
                  }}
                </legend>

                <input type="text" name="adress2" id="adress2" class="form-control" #autoInput2 matInput
                    [matAutocomplete]="auto2" (input)="onChange('shippingAdress')">

                <mat-autocomplete #auto2="matAutocomplete"
                    (optionSelected)="onSelectionChange($event, 'shippingAdress')">
                    <mat-option *ngFor="let place of places" [value]="place">
                        {{ place.description }}
                    </mat-option>
                </mat-autocomplete>
              </div> -->
                <div class="col-md-4 form-group">
                  <div class="position-relative form-group">
                    <legend for="numTel_society" class="">
                      {{ "data.Loading_time" | translate }}
                    </legend>
                    <div class="row">
                      <div class="col-12 col-md-4">
                        <select
                          class="form-control"
                          formControlName="startTravel"
                          name="startTravel"
                          id="startTravel"
                        >
                          <!-- <option [value]="null">Sélectionnez la poste du contact</option> -->
                          <option
                            [value]="item.value"
                            *ngFor="let item of timer"
                          >
                            {{ item.value }}
                          </option>
                        </select>
                      </div>
                      <div class="col-12 col-md-4">
                        <select
                          class="form-control"
                          formControlName="endTravel"
                          name="endTravel"
                          id="endTravel"
                        >
                          <!-- <option [value]="null">Sélectionnez la poste du contact</option> -->
                          <option
                            [value]="item.value"
                            *ngFor="let item of timer"
                          >
                            {{ item.value }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <div class="position-relative form-group">
                    <legend for="instraction_part" class="">
                      {{ "data.special_instructions" | translate }}
                    </legend>
                    <input
                      name="instraction_part"
                      id="instraction_part"
                      type="text"
                      class="form-control"
                      formControlName="instraction_part"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="card-header">{{ "data.info_goods" | translate }}</div>
            <div class="card-body">
              <div class="row form-group">
                <div class="col-md-6 form-group">
                  <div class="position-relative form-group">
                    <legend for="numTel_society" class="">
                      {{ "data.types_goods" | translate }}
                    </legend>
                    <input
                      name="type"
                      id="type"
                      type="text"
                      class="form-control"
                      formControlName="type"
                    />
                  </div>
                </div>
                <div class="col-md-6 form-group">
                  <div class="position-relative form-group">
                    <legend for="numTel_society" class="">
                      {{ "data.packaging" | translate }}
                    </legend>
                    <input
                      name="subType"
                      id="subType"
                      type="text"
                      class="form-control"
                      formControlName="subType"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="card-header">{{ "data.other_info" | translate }}</div>
            <div class="card-body">
              <div class="row form-group">
                <div class="col-md-12">
                  <legend for="firstName" class="">
                    {{ "data.notes_comments" | translate }}
                  </legend>
                  <textarea
                    name="text"
                    id="exampleText"
                    class="form-control"
                    style="height: 132px"
                    formControlName="comment"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="tab-content" id="tab-content">
          <div class="main-card mb-12 card">
            <div class="d-block text-center card-footer">
              <button
                class="mr-2 btn-icon btn-icon-only btn btn-outline-danger"
              >
                {{ "data.cancel" | translate }}
              </button>
              <div *ngIf="isSaved; else elseIsSaved">
                <div class="spinner-container blue-spinner">
                  <mat-progress-spinner
                    mode="indeterminate"
                    [diameter]="40"
                    [strokeWidth]="5"
                  ></mat-progress-spinner>
                </div>
              </div>
              <ng-template #elseIsSaved>
                <button class="btn-wide btn btn-primary" type="submit">
                  {{ "data.save" | translate }}
                </button>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
